import type {Serializable, SerializedFunnel} from '../types/serialized-cohort-types';
import type {FunnelStep} from './funnel-step';

export class Funnel implements Serializable {
  constructor(public steps: FunnelStep[]) {}

  public serialize(): SerializedFunnel {
    return {
      steps: this.steps.map((s) => s.serialize()),
    };
  }
}
